module.exports = __webpack_public_path__ + "img/2024-02-13a_3.335d65cd.jpg";